module.exports = __webpack_public_path__ + "img/aperture.ba28bb50.svg";